import {ref} from 'vue';

export default {
    install: (app, options) => {
        const broadcastListened = ref(false);

        app.provide('broadcastListened', broadcastListened);
    },
}
